import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      "max-width": "500",
      "persistent": ""
    },
    model: {
      value: _vm.internalOpen,
      callback: function ($$v) {
        _vm.internalOpen = $$v;
      },
      expression: "internalOpen"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    class: `headline ${_vm.color}--text`
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.title')) + "\n    ")]), _c(VCardText, {
    staticClass: "pt-4"
  }, [_vm.hasExistingConfig ? [_c('p', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.messageReuse', {
    date: _vm.lastDeactivatedDate
  })) + "\n        ")])] : [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.messageNew')))])]], 2), _c(VDivider), _c(VCardActions, [_c(VSpacer), _c(VBtn, {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.cancel')) + "\n      ")]), _vm.hasExistingConfig ? _c(VBtn, {
    attrs: {
      "color": _vm.color,
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.confirm(true);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.useOld')) + "\n      ")]) : _vm._e(), _vm.hasExistingConfig ? _c(VBtn, {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        return _vm.confirm(false);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.createNew')) + "\n      ")]) : _c(VBtn, {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        return _vm.confirm(false);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.dialogs.enable.create')) + "\n      ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };